import React, { useState, memo, useEffect } from 'react'

import { useAppSelector } from 'redux/Hook'
import GraphicalDetailsComp from 'components/Reporting/Overview/GraphicalDetails'
import {
  useKeyMetricsDetails,
  useActivityOverTime,
  useVisitorEngagement,
  useTopPerformingTools,
  useContributedTags,
  useContributedLocations,
} from 'containers/Reporting/Shared/CardContainer/index'
import ReportingDashboardFilter from 'containers/Reporting/Shared/Filters/ReportingDashboardFilter'
import { activityOverTimeSwitcher } from 'containers/Reporting/Shared/Constants'
import { setFilterDropdown } from 'containers/Reporting/Shared/Filters/ActivityOverTimeHelper'
import { SelectDropdown as SelectDropdownType } from 'types/SelectDropdown'
import { ActivityFilterSelection } from 'containers/Reporting/Shared/Types'
import usePrevious from 'lib/hooks/UsePrevious'

const GraphicalDetails = () => {
  const currentUser = useAppSelector((state) => state.user.user)
  const selectedFilters = useAppSelector(
    (state) => state.filterBuilder.selectedFilters,
  )
  const dateRange =
    selectedFilters.filter((f: any) => f?.name === 'dateRange')[0]?.dateRange ||
    {}
  const prevProps = usePrevious({ selectedFilters })

  const [activityFilterOptions, setActivityFilterOptions] =
    useState<SelectDropdownType>([])
  const [activityFilterSelection, setPeriodFilter] =
    useState<ActivityFilterSelection>({
      period: 'daily',
    }) // object used to get immediate state update, with prevProps, with string update states are not updating as expected

  const { keyMetrics, isKeyMetricsLoading } = useKeyMetricsDetails()

  const { activityData, isActivityLoading } = useActivityOverTime(
    activityFilterSelection,
  )

  const { visitorEngagementData, isVisitorEngagementLoading } =
    useVisitorEngagement()

  const { topPerformingToolsData, isTopPerformingToolsLoading } =
    useTopPerformingTools()

  const { contributionTagsData, isContributionTagsLoading } =
    useContributedTags()

  const { contributionsLocationData, isContributionsLocationLoading } =
    useContributedLocations()

  useEffect(() => {
    const period = setFilterDropdown({
      dateRange,
      activityFilterOptions,
    })
    period &&
      setPeriodFilter((prevState: any) => ({
        ...prevState.activityOverTimeSelection,
        period,
      }))
  }, [])

  useEffect(() => {
    if (
      prevProps &&
      JSON.stringify(prevProps?.selectedFilters) !==
        JSON.stringify(selectedFilters)
    ) {
      const period = setFilterDropdown({
        option: 'monthly',
        dateRange,
        activityFilterOptions,
      })
      period &&
        setPeriodFilter((prevState: any) => ({
          ...prevState.activityOverTimeSelection,
          period,
        }))
    }
  }, [selectedFilters])

  const onSetActivityFilterDropdown = async (options: string) => {
    await setPeriodFilter((prevState: any) => ({
      ...prevState.activityOverTimeSelection,
      period: options,
    }))
  }

  useEffect(() => {
    setActivityFilterOptions(activityOverTimeSwitcher)
  }, [currentUser])

  return (
    <>
      <ReportingDashboardFilter>
        <GraphicalDetailsComp
          isLoading={{
            isKeyMetricsLoading,
            isActivityLoading,
            isVisitorEngagementLoading,
            isTopPerformingToolsLoading,
            isContributionTagsLoading,
            isContributionsLocationLoading,
          }}
          keyMetrics={keyMetrics}
          activityData={activityData}
          visitorEngagementData={visitorEngagementData}
          topPerformingToolsData={topPerformingToolsData}
          contributionTagsData={contributionTagsData}
          contributionsLocationData={contributionsLocationData}
          onSetActivityFilterDropdown={onSetActivityFilterDropdown}
          activityOverTimeOptions={activityOverTimeSwitcher}
          activityOverTimeSelection={activityFilterSelection}
        />
      </ReportingDashboardFilter>
    </>
  )
}

export default memo(GraphicalDetails)
